import { Box, Typography } from "@mui/material";
import { V2_COLORS } from "@/pages/InvoiceManagement/v2/constants/colors";

interface StatusMeta {
  label: string;
  color: string;
  bgColor: string;
}

export const RFQ_STATUS_META: Record<string, StatusMeta> = {
  OPEN: { label: "New RFQ", color: V2_COLORS.primary, bgColor: V2_COLORS.primaryBg },
  SUBMITTED: { label: "Submitted", color: V2_COLORS.warning, bgColor: V2_COLORS.warningBg },
  ALLOTTED: { label: "Allotted", color: V2_COLORS.success, bgColor: V2_COLORS.successBg },
  DECLINED: { label: "Declined", color: V2_COLORS.error, bgColor: V2_COLORS.errorBg },
  EXPIRED: { label: "Expired", color: V2_COLORS.textSecondary, bgColor: V2_COLORS.bgMuted },
  CLOSED: { label: "Closed", color: V2_COLORS.textSecondary, bgColor: V2_COLORS.bgMuted },
};

export default function RfqStatusBadge({ status }: { status: string }) {
  const meta = RFQ_STATUS_META[status] ?? { label: status, color: V2_COLORS.textSecondary, bgColor: V2_COLORS.bgMuted };
  return (
    <Box
      component="span"
      data-testid="rfq-status-badge"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        px: "8px",
        py: "4px",
        borderRadius: "4px",
        color: meta.color,
        backgroundColor: meta.bgColor,
        whiteSpace: "nowrap",
      }}
    >
      <Typography component="span" sx={{ color: "inherit", fontSize: "10px", fontWeight: 500, lineHeight: "12px", textTransform: "uppercase" }}>
        {meta.label}
      </Typography>
    </Box>
  );
}
